import { graphql } from 'gql';

export const getWorkOrderOtherData = graphql(`
    query uerWorkOrderOtherPrices(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $workOrderRootObjectId: Long!
        $where: WorkOrderOtherPriceDataFilterInput
    ) {
        uerWorkOrderOtherPrices(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            workOrderRootObjectId: $workOrderRootObjectId
            where: $where
        ) {
            totalCount
            items {
                id
                contractOtherId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                rationale
                status
                totalPlanCost
                totalCompletedCost
                totalRemainderCost
                seasonPrices {
                    seasonId
                    planCost
                    completedCost
                    remainderCost
                    isReadOnly
                    errors
                    hasErrors
                }
                actKC2Prices {
                    acceptedCost
                    acceptedCostDeviation
                    actKC2Id
                    isCorrection
                    isInactive
                    planCost
                    planCostDeviation
                }
                hasEmptySeasonCost
                hasEmptyActPlanCost
                hasEmptyActAcceptedCost
                isActKC2Price
                isExcludedPrice
                hasLimitSpan
            }
        }
    }
`);

export const updateActKC2OtherCostPlanCost = graphql(`
    mutation uerSetActKC2OtherCostPlanCost($actKC2Id: Long!, $workOrderOtherId: Long!, $cost: Decimal!) {
        uerSetActKC2OtherCostPlanCost(actKC2Id: $actKC2Id, workOrderOtherId: $workOrderOtherId, cost: $cost) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateActKC2OtherCostAcceptedCost = graphql(`
    mutation uerSetActKC2OtherCostAcceptedCost($actKC2Id: Long!, $workOrderOtherId: Long!, $cost: Decimal!) {
        uerSetActKC2OtherCostAcceptedCost(actKC2Id: $actKC2Id, workOrderOtherId: $workOrderOtherId, cost: $cost) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getOrderOtherStatusFilterItems = graphql(`
    query uerWorkOrderOtherPriceStatusFilter(
        $workOrderId: Long!
        $workOrderOtherPriceObjectId: Long!
        $where: FilterValueOfContractOtherStatusEnumFilterInput
    ) {
        uerWorkOrderOtherPriceStatusFilter(
            workOrderId: $workOrderId
            workOrderOtherPriceObjectId: $workOrderOtherPriceObjectId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);
export const getOrderOtherNameFilterItems = graphql(`
    query uerWorkOrderOtherPriceNameFilter(
        $workOrderId: Long!
        $workOrderOtherPriceObjectId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderOtherPriceNameFilter(
            workOrderId: $workOrderId
            workOrderOtherPriceObjectId: $workOrderOtherPriceObjectId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);
